import {SimulationBO} from "../PA.Simulation.BusinessObjects/SimulationBO";
import {IMessageProvider, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {BehaviorSubject} from "rxjs";
import {
    ISimulationCalculatorCalculateOptions,
    ISimulationCalculatorCalculateResults
} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import {IMetricParameterSet} from "../PA.Metric.Services/PA.Metrics.IF";


export interface ISummaryMetricsRequest {
    RequestType: string,
    modelingSessionIds: number[],
    mapeRanges:  MapeRange[],
    dataSetParts: DataSetPart[]
}

export interface IMAPEPrdGrpSummaryRequest {
    RequestType: string,
    modelingSessionIds: number[],
    mapeRanges:  MapeRange[],
    dataSetParts: DataSetPart[],
    customerIds: number[],
    prdGrpIds: number[],
    productLeafIds: number[]
}

export interface IModelingScorecardServiceResponse {
    bSuccess: boolean;
    sWarnings: string[];
    sErrors: string[];
    results: any;
}

export enum MapeRange {
    Range_0_20 =    "Less than 20%",
    Range_21_30 =   "20% - 30%",
    Range_Over30 =  "Greater than 30%"
}

export enum DataSetPart {
    Training =  "Training",
    HoldOut =   "Holdout"
}

export interface IWeightedMAPEByCustomer {
    wbCustId:           number,
    customerName:       string,
    DataSetPart:        DataSetPart,
    MAPE_Promoted:      number,
    MAPE_NonPromoted:   number,
    MAPE_Total:         number
}

export interface IWeightedMAPEByProduct {
    wbPrdGrpId:         number,
    productName:        string,
    DataSetPart:        DataSetPart,
    MAPE_Promoted:      number,
    MAPE_NonPromoted:   number,
    MAPE_Total:         number
}

export interface IWeightedMAPEByPPG {
    wbPrdGrpId:         number,
    productGroupName:   string,
    DataSetPart:        DataSetPart,
    MAPE_Promoted:      number,
    MAPE_NonPromoted:   number,
    MAPE_Total:         number
}


export interface IActualPredictedUnits {
    wbPeriodId:         number,
    PeriodEndDate:      string,
    DataSetPart:        DataSetPart,
    Predicted_Volume:   number,
    Actual_Volume:      number
}

export interface IModelingScorecardService {


    //KPI metrics

    //chart 1
    getSummarySalesMetrics(arrWbModelingSessionIds: number[], mapeRanges:  MapeRange[], dataSetParts: DataSetPart[]): Promise<{mapeRange: MapeRange, retailSales: number}[]>

    //chart 2
    getSummaryCustPPGMetrics(arrWbModelingSessionIds: number[], mapeRanges:  MapeRange[], dataSetParts: DataSetPart[]): Promise<{mapeRange: MapeRange, DistinctCustomerProducts: number}[]>

    //chart 3
    getModelingSessionMAPECustomerSummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds: number[]): Promise<IWeightedMAPEByCustomer[]>

    //chart 4
    getModelingSessionMAPEProductSummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds: number[], hierarchyLevel: string): Promise<IWeightedMAPEByProduct[]>

    //chart 5
    getModelingSessionMAPEPrdGrpSummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds: number[], wbPrdGrpIds: number[], wbPrdIds_Leaf: number[]): Promise<IWeightedMAPEByPPG[]>

    //chart 6
    getModelingSessionActualPredictedUnits(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds: number[], wbPrdGrpIds: number[], wbPrdIds_Leaf: number[]): Promise<IActualPredictedUnits[]>

    //last 2 KPI metrics
    getModelingSessionKPISummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts?: DataSetPart[], arrWBCustIds?: number[], wbPrdGrpIds?: number[], wbPrdIds_Leaf?: number[]): Promise<{mapeTraining: number, mapeHoldout: number}>

}
